import React, { lazy } from 'react';
const AddCustomer = lazy(() => import("./pages/Customers/AddCustomer"));
const Customers = lazy(() => import("./pages/Customers/Customers"));
const EditCustomer = lazy(() => import("./pages/Customers/EditCustomer"));
const GeoLocation = lazy(() => import("./pages/Customers/GeoLocation"));
//import Dashboard from "./pages/Dashboard";
const Dashboard = lazy(() => import("./pages/Dashboard/Dashboard"));
const AddIhouseEmployeedupli = lazy(() => import("./pages/Employees/AddIhouseEmployeedupli"));
const EditEmployee = lazy(() => import("./pages/Employees/EditEmployee"));
const InhouseEmployees = lazy(() => import("./pages/Employees/InhouseEmployees"));
const InhouseEmployeesdupli = lazy(() => import("./pages/Employees/InhouseEmployeesdupli"));
const InhouseEmployeetry = lazy(() => import("./pages/Employees/InhouseEmployeetry"));
const CreateIdea = lazy(() => import("./pages/Invoices/CreateIdea"));
const CreateInvoice = lazy(() => import("./pages/Invoices/CreateInvoice"));
const ManageRoleAndMenu = lazy(() => import("./pages/ManageRoleAndMenu"));
const AddMarketingActivity = lazy(() => import("./pages/MarketingActivity/AddMarketingActivity"));
const EditMarketingActivity = lazy(() => import("./pages/MarketingActivity/EditMarketingActivity"));
const MarketingActivities = lazy(() => import("./pages/MarketingActivity/MarketingActivities"));
const AddPrice = lazy(() => import("./pages/Price/AddPrice"));
const CreateSalesOrderInternal = lazy(() => import("./pages/Invoices/CreateSalesOrderInternal"));
const Price = lazy(() => import("./pages/Price/Price"));
const AddProduct = lazy(() => import("./pages/Products/AddProduct"));
const EditProduct = lazy(() => import("./pages/Products/EditProduct"));
const MapProduct = lazy(() => import("./pages/Products/MapProduct"));
const Products = lazy(() => import("./pages/Products/Products"));
const ChangePassword = lazy(() => import("./user/ChangePassword"));

const Signup = lazy(() => import("./user/Signup"));
const MarketingActivitiesDupli = lazy(() => import("./pages/MarketingActivity/MarketingActivitiesDupli"));
const CustomerMap = lazy(() => import("./pages/Customers/CustomerMap"));
const MarketingReport = lazy(() => import("./pages/Reports/MarketingReports"));
const MarketingReportMap = lazy(() => import("./pages/MarketingActivity/MarketingReportMap"));
const AddTallySales = lazy(() => import("./pages/TallySales/AddTallySales"));
const UpdateProductSample = lazy(() => import("./pages/Products/UpdateProductSample"));
const EditSalesOrderInternal = lazy(() => import("./pages/Invoices/EditSalesOrderInternal"));
const EscalateSalesOrderInternal = lazy(() => import("./pages/Invoices/EscalateSalesOrderInternal"));
const AddSupplier = lazy(() => import("./pages/Suppliers/AddSupplier"));
const PackageSalesOrderInternal = lazy(() => import("./pages/Invoices/PackagingSalesOrderInternal"));
const EscalatedSalesOrderInternals = lazy(() => import("./pages/Invoices/EscalatedSalesOrderInternals"));
const PackagedSalesOrderInternal = lazy(() => import("./pages/Invoices/PackagedSalesOrderInternal"));
const EditDemo = lazy(() => import("./pages/Invoices/EditDemo"));
const PackageDoneSalesOrderInternal = lazy(() => import("./pages/Invoices/PackageDoneSalesOrderInternal"));
const EditPackagedSalesOrderInternal = lazy(() => import("./pages/Invoices/EditPackagedSalesOrderInternal"));
const PackagingSalesOrderInternal = lazy(() => import("./pages/Invoices/PackagingSalesOrderInternal"));
const Suppliers = lazy(() => import("./pages/Suppliers/Suppliers"));
const EditSupplier = lazy(() => import("./pages/Suppliers/EditSupplier"));
const UserRoles = lazy(() => import("./pages/Registrations/UserRoles"));
const SalesOrderInternal = lazy(() => import("./pages/Invoices/SalesOrderInternal"));
const AssignCustomersToEmployee = lazy(() => import("./pages/AssignCustomersToEmployee"));
const CreateStockIn = lazy(() => import("./pages/stockin/CreateStockIn"));
const PurchasePrice = lazy(() => import("./pages/PurchasePrice/PurchasePrice"));
const AddPurchasePrice = lazy(() => import("./pages/PurchasePrice/AddPurchasePrice"));
const EditPurchasePrice = lazy(() => import("./pages/PurchasePrice/EditPurchasePrice"));
const EditPrice = lazy(() => import("./pages/Price/EditPrice"));
const Batches = lazy(() => import("./pages/Batches/Batches"));
const Stockin = lazy(() => import("./pages/stockin/Stockin"));
const EditStockin = lazy(() => import("./pages/stockin/EditStockin"));
const UpdateStockinQuantity = lazy(() => import("./pages/stockin/UpdateStockinQuantity"));
const StockinForConfirmation = lazy(() => import("./pages/stockin/StockinForConfirmation"));
const CreateQuotation = lazy(() => import("./pages/Quotations/CreateQuotation"));
const EditQuotation = lazy(() => import("./pages/Quotations/EditQuotation"));
const ApproveQuotation = lazy(() => import("./pages/Quotations/ApproveQuotation"));
const AddCheque = lazy(() => import("./pages/Cheque/AddCheque"));
const EditCheque = lazy(() => import("./pages/Cheque/EditCheque"));
const Cheques = lazy(() => import("./pages/Cheque/Cheques"));
const QuotationApprovedList = lazy(() => import("./pages/Quotations/QuotationApprovedList"));
const AddPayment = lazy(() => import("./pages/Payment/AddPayment"));
const Payments = lazy(() => import("./pages/Payment/Payments"));
const EditPayment = lazy(() => import("./pages/Payment/EditPayment"));
const QuotationUnapprovedList = lazy(() => import("./pages/Quotations/QuotationUnapproved"));
const Quotations = lazy(() => import("./pages/Quotations/Quotations"));
const AddTask = lazy(() => import("./pages/Tasks/AddTask"));
const EditTask = lazy(() => import("./pages/Tasks/EditTask"));
const CreateStockInForm = lazy(() => import("./pages/stockin/CreateStockIn"));
const AddDelivery = lazy(() => import("./pages/Tasks/AddDelivery"));
const IncompleteTask = lazy(() => import("./pages/Tasks/IncompleteTask"));

const StockoutStatus = lazy(() => import("./pages/Invoices/StockoutStatus"));
const UnAssignedTask = lazy(() => import("./pages/Tasks/UnAssignedTask"));
const UpdateStockoutStatus = lazy(() => import("./pages/Invoices/UpdateStockoutStatus"));

const SalesReport = lazy(() => import("./pages/Reports/SalesReport"));
const DeliveryReport = lazy(() => import("./pages/Reports/DeliveryReport"));
const ProductStockOutReport = lazy(() => import("./pages/Reports/SalesReportByProduct"));
const ProductStockInReport = lazy(() => import("./pages/Reports/ProductStockIn"));
const PaymentReport = lazy(() => import("./pages/Reports/PaymentReport"));
const MappingReport = lazy(() => import("./pages/Reports/MappingReport"));
const DeliveryConveyanceReport = lazy(() => import("./pages/Reports/DeliveryConveyanceReport"));
const MonthlyCreditReportForMd = lazy(() => import("./pages/Reports/MarketingReports/MonthlyCreditReportForMd"));

//Admin Edit

//import SalesOrderInternalGeneralEdit from "./pages/AdminEdit/SalesOrderInternalGeneralEdit";
const SalesOrderInternalGeneralEdit = lazy(() => import("./pages/AdminEdit/SalesOrderInternalGeneralEdit"));
const EscalateSalesOrderInternalWithPriceEdit = lazy(() => import("./pages/AdminEdit/SalesInvoiceAdminEdit/EscalateSalesOrderInternalWithPriceEdit"));
const EditSalesOrderInternalAdmin = lazy(() => import("./pages/AdminEdit/SalesOrderAdminEdit/EditSalesOrderInternalAdmin"));
const EditSalesOrderPacking = lazy(() => import("./pages/AdminEdit/SalesPackingEdit/EditSalesOrderPacking"));
const SalesPendingPrice = lazy(() => import("./pages/AdminEdit/SalesPendingPriceAdminGrid/SalesPendingPrice"));

// stock Adjustment

const CreatestockAdjustment = lazy(() => import("./pages/StockAdjustment/CreatestockAdjustment"));
const StockAdjustmentReport = lazy(() => import("./pages/Reports/StockAdjustmentReport"));

const CustomerList = lazy(() => import("./pages/Customers/CustomerList"));

//shahed
const MiniInvoiceLabelSticker = lazy(() => import("./pages/Invoices/MiniInvoiceLabelSticker"));
const SalesOrderLimitedEdit = lazy(() => import("./pages/AdminEdit/SalesOrderLimitedEditGrid"));
const LimitedItemsEidtAtInvoice = lazy(() => import("./pages/AdminEdit/SalesInvoiceAdminEdit/LimitedItemsEidtAtInvoice"));
const LocationList = lazy(() => import("./pages/Locations/LocationList"));
const AddLocation = lazy(() => import("./pages/Locations/AddLocation"));
const EditLocation = lazy(() => import("./pages/Locations/EditLocation"));

const ListProductFunction = lazy(() => import("./pages/Products/ProductFunction/ListProductFunction"));
const CreateProductFunction = lazy(() => import("./pages/Products/ProductFunction/CreateProductFunction"));
const UpdateProductFunction = lazy(() => import("./pages/Products/ProductFunction/UpdateProductFunction"));

const SalesOrderPackageStickerList = lazy(() => import("./pages/Sticker/RepackingSticker/SalesOrderPackageStickerList"));
const StockOutDefinePackingForSticker = lazy(() => import("./pages/Sticker/RepackingSticker/StockOutDefinePackingForSticker"));
const EditStockOutDefinePackingForSticker = lazy(() => import("./pages/Sticker/RepackingSticker/EditStockOutDefinePackingForSticker"));

const PrintInfoPanel = lazy(() => import("./pages/Sticker/PrintInfoPanel"));
//import SampleStickerPanel from "./pages/Sticker/SampleStickerPanel";
//Rakib
const DefinePending = lazy(() => import("./pages/Invoices/DefinePending"));
const AssignedTask = lazy(() => import("./pages/Tasks/AssignedTask"));
const IncompleteChecklistTask = lazy(() => import("./pages/Tasks/IncompleteChecklistTask"));
const EditTaskPendingChecklist = lazy(() => import("./pages/Tasks/EditTaskPendingChecklist"));
const CurrentStockReport = lazy(() => import("./pages/Reports/CurrentStockReport"));
const PendingAndCancelReport = lazy(() => import("./pages/Reports/PendingAndCancelReport"));
const DailyInvoiceTracking = lazy(() => import("./pages/Reports/DailyInvoiceTracking"));
const LoanDetails = lazy(() => import("./pages/Reports/ProductLoan"));


const AllowanceChecking = lazy(() => import("./pages/Reports/AllowanceChecking"));
const SampleStickerPanel = lazy(() => import("./pages/Sticker/SampleStickerPanel"));

//barcode
const StockInCrateBarcode = lazy(() => import("./pages/BarCode/CreateBarcode"));
const ListBarcodePrint = lazy(() => import("./pages/BarCode/PrintBarcode"));
const RepackingBocodeList = lazy(() => import("./pages/BarCode/RepackingBarcodePrintList"));
const CreateBarcodeRepack = lazy(() => import("./pages/BarCode/CreateRepackingBarcode"));
const StockOutBarcodeMap = lazy(() => import("./pages/BarCode/StockOutBarcodeMap"));

//stock In
const StockInInvoiceList = lazy(() => import("./pages/stockin/StockInInvoiceList"));

//Batch Report
const BatchReportStockOut = lazy(() => import("./pages/Reports/BatchInfo/BatchReportStockOut"));
const LCList = lazy(() => import("./pages/LC/LCList"));
const BatchReportForStockIn = lazy(() => import("./pages/Reports/BatchInfo/BatchReportForStockIn"));
const CustomerCreditReport = lazy(() => import("./pages/Reports/CustomerCredit/CreditInfo"));

// Stock IN Admin Action
const StockInAdminAction = lazy(() => import("./pages/stockin/StockRevert/ListStockInApproved"));
const StockInAdminRevert = lazy(() => import("./pages/stockin/StockRevert/StockInAdminRevert"));
const StockInPriceEditList = lazy(() => import("./pages/stockin/StockInPriceEditList"));
const StockInPriceUpdate = lazy(() => import("./pages/stockin/StockInPriceUpdate"));
const ProdctInReport = lazy(() => import("./pages/stockin/ProdctInReport"));


//LC
const PiLists = lazy(() => import("./pages/LetterOfCredit/PiLists"));
const CreatePI = lazy(() => import("./pages/LetterOfCredit/CreatePI"));
const UpdatePI = lazy(() => import("./pages/LetterOfCredit/UpdatePI"));
const CustomerPaymentSales = lazy(() => import("./pages/Reports/CustomerPaymentSales"));
const LcDocAndPaymentList = lazy(() => import("./pages/LetterOfCredit/LcDocAndPaymentList"));
const LcDocAndPaymentCreate = lazy(() => import("./pages/LetterOfCredit/LcDocAndPaymentCreate"));
const LcLimitedUpdate = lazy(() => import("./pages/LetterOfCredit/LcLimitedUpdate.js"));
const DocumentActionList = lazy(() => import("./pages/LetterOfCredit/DocumentActionList"));
const LCPaymentList = lazy(() => import("./pages/LetterOfCredit/LCPaymentList"));
const LCPaymentEntry = lazy(() => import("./pages/LetterOfCredit/LCPaymentEntry"));
const LCTrackingReport = lazy(() => import("./pages/LetterOfCredit/LCTrackingReport"));
const LcPaymentEdit = lazy(() => import("./pages/LetterOfCredit/LcPaymentEdit"));
const LcPaymentEditList = lazy(() => import("./pages/LetterOfCredit/LcPaymentEditList"));
const LcDocAndPaymentUpdate = lazy(() => import("./pages/LetterOfCredit/LcDocAndPaymentUpdate"));

// report
const LoanReports = lazy(() => import("./pages/Reports/ProductLoan/LoanReports"));
const PurchasePriceHistoryReport = lazy(() => import("./pages/Reports/ProductStockIn/PurchasePriceHistoryReport"));
const StockInReportWithAdjustment = lazy(() => import("./pages/Reports/ProductStockIn/StockInReportWithAdjustment"));
const EmployeeTaskReport = lazy(() => import("./pages/Reports/EmployeeTaskReport"));
const DashboardLive = lazy(() => import("./pages/DashboardLive/DashboardLive"));
const ProductOutForAdmin = lazy(() => import("./pages/Reports/SalesReportByProduct/ProductOutForAdmin"));
const RepackingPackedByReport = lazy(() => import("./pages/Reports/PackingBy/RepackingPackedByReport"));
const CurrentStockByProduct = lazy(() => import("./pages/Reports/CurrentStockReport/CurrentStockByProduct"));
const CustomerFlagUpdate = lazy(() => import("./pages/Customers/CustomerFlagUpdate"));
const CurrentStockReconcileAuditReports = lazy(() => import("./pages/Reports/CurrentStockReport/CurrentStockReconcileAuditReports"));
const TaxAitDetailsReport = lazy(() => import("./pages/Reports/CustomerTaxDuty/TaxAitDetailsReport"));
const TaxAitSummaryReport = lazy(() => import("./pages/Reports/CustomerTaxDuty/TaxAitSummaryReport"));
const StockInSummaryReport = lazy(() => import("./pages/Reports/ProductStockIn/StockInSummaryReport"));
const ReportStockOutWithStockIn = lazy(() => import("./pages/Reports/StockOutWithIn/ReportStockOutWithStockIn"));
//tax and duty
const TaxAndDutyList = lazy(() => import("./pages/Customers/TaxAndDuty/TaxAndDutyList"));
const AddTaxAndDuty = lazy(() => import("./pages/Customers/TaxAndDuty/AddTaxAndDuty"));
const EditTaxAndDuty = lazy(() => import("./pages/Customers/TaxAndDuty/EditTaxAndDuty"));

const DeliveryReturnInventoryRestoration = lazy(() => import("./pages/Invoices/DeliveryReturnInventoryRestoration"));
const EscalationListPage = lazy(() => import("./pages/escalation/EscalationListPage"));
const EscalationCockpitPage = lazy(() => import("./pages/escalation/EscalationCockpitPage"));
const AddTaskInvoiceFree = lazy(() => import("./pages/Tasks/AddTaskInvoiceFree"));
const reportRoutes = [
  {
    path: "/report/sales",
    component: SalesReport,
  },
  {
    path: "/report/payment",
    component: PaymentReport,
  },
  {
    path: "/report/mapped",
    component: MappingReport,
  },
  {
    path: "/report/delivery-conveyance",
    component: DeliveryConveyanceReport,
  },
  {
    path: "/report/currentstock",
    component: CurrentStockReport,
  },
  {
    path: "/report/employee-task",
    component: EmployeeTaskReport,
  },
];

export const routes = [
  {
    path: "/signup",
    component: Signup,
  },
  {
    path: "/roles/users",
    component: UserRoles,
  },
  {
    path: "/",
    component: Dashboard,
  },
  {
    path: "/dashboard",
    component: Dashboard,
  },
  {
    path: "/inhouseemployees",
    component: InhouseEmployeesdupli,
  },
  {
    path: "/addemployee",
    component: AddIhouseEmployeedupli,
  },
  {
    path: "/employee/:id/edit",
    component: EditEmployee,
  },
  {
    path: "/products",
    component: Products,
  },
  {
    path: "/products/sample/update",
    component: UpdateProductSample,
  },
  {
    path: "/addproduct",
    component: AddProduct,
  },
  {
    path: "/product/:id/edit",
    component: EditProduct,
  },
  {
    path: "/customers",
    component: Customers,
  },
  {
    path: "/addcustomer",
    component: AddCustomer,
  },
  {
    path: "/customer/:id/edit",
    component: EditCustomer,
  },
  {
    path: "/customers/map",
    component: CustomerMap,
  },
  {
    path: "/addsellprice",
    component: AddPrice,
  },
  {
    path: "/price",
    component: Price,
  },
  {
    path: "/price/:id/edit",
    component: EditPrice,
  },
  {
    path: "/manageroleandmenu",
    component: ManageRoleAndMenu,
  },
  {
    path: "/marketingactivities",
    component: MarketingActivities,
  },
  {
    path: "/addmarketingactivity",
    component: AddMarketingActivity,
  },
  {
    path: "/marketingactivity/:id/edit",
    component: EditMarketingActivity,
  },
  {
    path: "/marketing/report/map",
    component: MarketingReportMap,
  },
  {
    path: "/mappingproduct",
    component: MapProduct,
  },
  {
    path: "/geolocation",
    component: GeoLocation,
  },
  {
    path: "/salesorderinternal",
    component: SalesOrderInternal,
  },
  {
    path: "/salesorderinternal/create",
    component: CreateSalesOrderInternal,
  },
  
  // {
  //   path: "/marketing/report",
  //   component: MarketingReport,
  // },

  {
    path: "/report/marketingvisit",
    component: MarketingReport,
  },

  {
    path: "/tallysales/add",
    component: AddTallySales,
  },
  {
    path: "/salesorderinternal/:id/edit",
    component: EditSalesOrderInternal,
  },
  {
    path: "/salesorderinternal/:id/action",
    component: EscalateSalesOrderInternal,
  },
  {
    path: "/salesorderinternal/:id/package",
    component: PackagingSalesOrderInternal,
  },
  {
    path: "/salesorderinternal/escalationlist",
    component: EscalatedSalesOrderInternals,
  },
  {
    path: "/salesorderinternal/packagelist",
    component: PackagedSalesOrderInternal,
  },
  {
    path: "/salesorderinternal/packagelist/done",
    component: PackageDoneSalesOrderInternal,
  },
  {
    path: "/packagelist/done/:id/edit",
    component: EditPackagedSalesOrderInternal,
  },
  {
    path: "/suppliers/add",
    component: AddSupplier,
  },
  {
    path: "/supplier/:id/edit",
    component: EditSupplier,
  },
  {
    path: "/suppliers",
    component: Suppliers,
  },
  {
    path: "/lc/list",
    component: LCList,
  },
  {
    path: "/assignemployeetocustomers",
    component: AssignCustomersToEmployee,
  },
  {
    path: "/stockin/create",
    component: CreateStockInForm,
  },
  {
    path: "/stockin/list",
    component: Stockin,
  },
  {
    path: "/stockin/unapprovedqty/list",
    component: StockinForConfirmation,
  },
  {
    path: "/stockin/:id/edit",
    component: EditStockin,
  },
  {
    path: "/stockin/:id/confirmQty",
    component: UpdateStockinQuantity,
  },
  {
    path: "/purchaseprices",
    component: PurchasePrice,
  },
  {
    path: "/purchaseprice/add",
    component: AddPurchasePrice,
  },
  {
    path: "/purchaseprice/:id/edit",
    component: EditPurchasePrice,
  },
  {
    path: "/batches",
    component: Batches,
  },
  {
    path: "/quotation/list",
    component: Quotations,
  },
  {
    path: "/quotation/unapprovedlist",
    component: QuotationUnapprovedList,
  },
  {
    path: "/quotation/approvedlist",
    component: QuotationApprovedList,
  },
  {
    path: "/quotation/create",
    component: CreateQuotation,
  },

  {
    path: "/quotation/:id/edit",
    component: EditQuotation,
  },
  {
    path: "/quotation/:id/approve",
    component: ApproveQuotation,
  },
  {
    path: "/cheque/list",
    component: Cheques,
  },
  {
    path: "/cheque/create",
    component: AddCheque,
  },
  {
    path: "/cheque/:id/edit",
    component: EditCheque,
  },
  {
    path: "/payment/list",
    component: Payments,
  },
  {
    path: "/payment/create",
    component: AddPayment,
  },
  {
    path: "/payment/:id/edit",
    component: EditPayment,
  },
  // {
  //   path: "/task/create",
  //   component: AddTask,
  // },
  {
    path: "/task/:id/edit",
    component: EditTask,
  },
  {
    path: "/task/:id/editpendingchecklist",
    component: EditTaskPendingChecklist,
  },
  {
    path: "/delivery/create",
    component: AddDelivery,
  },
  {
    path: "/task/incompletelist",
    component: IncompleteTask,
  },
  {
    path: "/task/assignedlist",
    component: AssignedTask,
  },
  {
    path: "/task/incompletechecklist",
    component: IncompleteChecklistTask,
  },

  {
    path: "/task/assign",
    component: UnAssignedTask,
  },
  {
    path: "/stockout/status",
    component: StockoutStatus,
  },
  /*{
    path: "/stockout/update",
    component: UpdateStockoutStatus,
  },*/
  {
    path: "/stockout/update",
    component: DefinePending,
  },
  {
    path: "/report/sales",
    component: SalesReport,
  },
  {
    path: "/report/delivery",
    component: DeliveryReport,
  },
  {
    path: "/report/payment",
    component: PaymentReport,
  },
  {
    path: "/report/mapped",
    component: MappingReport,
  },
  {
    path: "/report/delivery-conveyance",
    component: DeliveryConveyanceReport,
  },
  {
    path: "/report/currentstock",
    component: CurrentStockReport,
  },
  {
    path: "/report/employee-task",
    component: EmployeeTaskReport,
  },
  {
    path: "/report/productout",
    component: ProductStockOutReport,
  },
  {
    path: "/report/productin",
    component: ProductStockInReport,
  },
  {
    path: "/report/productin-with-adjustment",
    component: StockInReportWithAdjustment,
  },
  {
    path: "/report/pending-and-cancel-report",
    component: PendingAndCancelReport,
  },
  {
    path: "/report/daily-invoice-tracking",
    component: DailyInvoiceTracking,
  },
  {
    path: "/salesorderinternal/general",
    component: SalesOrderInternalGeneralEdit,
  },
 
  {
    path: "/salesorder/limitededit",
    component: SalesOrderLimitedEdit,
  },
  {
    path: "/salesorder/:id/invoicelimitededit",
    component: LimitedItemsEidtAtInvoice,
  },
 
  {
    path: "/salesorderinternal/:id/action/price",
    component: EscalateSalesOrderInternalWithPriceEdit,
  },
  {
    path: "/salesorderinternal/admin/:id/edit",
    component: EditSalesOrderInternalAdmin,
  },
  {
    path: "/packagelist/done/admin/:id/edit",
    component: EditSalesOrderPacking,
  },
  {
    path: "/salesorderinternal/pendingprice",
    component: SalesPendingPrice,
  },

  {
    path: "/stockin/stockadjustment",
    component: CreatestockAdjustment,
  },
  {
    path: "/report/stockin/stockadjustmentreport",
    component: StockAdjustmentReport,
  },
  
  {
    path: "/customers/customerlist",
    component: CustomerList,
  
  },
  {
    path: "/packingessential/packingrelatedprint",
    component: MiniInvoiceLabelSticker,
  
  },

  {
    path: "/locationlist",
    component: LocationList,
  
  },
  {
    path:"/location/add",
    component: AddLocation
  },
  {
    path:"/location/:id/edit",
    component: EditLocation
  },
  {
    path: "/productfunctionlist",
    component: ListProductFunction,
  
  },
  {
    path:"/function/add",
    component: CreateProductFunction
  },
  {
    path:"/function/:id/edit",
    component: UpdateProductFunction
  },
  {
    path:"/stockoutpackagesticker/orderlist",
    component: SalesOrderPackageStickerList
  },
  {
    path: "/stockoutpackagesticker/:id/definepacking",
    component: StockOutDefinePackingForSticker,
  },
  {
    path: "/stockoutpackagesticker/:id/editdefinepacking",
    component: EditStockOutDefinePackingForSticker,
  },
  {
    path:"/sampleSticker/print",
    component:SampleStickerPanel,
  },
  {
    path:"/packing/printpanel",
    component:PrintInfoPanel
  },
  {
    path:"/allowance/checking",
    component:AllowanceChecking
  },

  {
    path:"/barcode/stockout",
    component:StockOutBarcodeMap
  },

  {
    path:"/barcode/listprint",
    component:ListBarcodePrint
  },
  {
    path:"/barcode/createbarcode",
    component:StockInCrateBarcode
  },
  {
    path:"/barcode/repackingbarcodelist",
    component:RepackingBocodeList
  },
  {
    path:"/barcode/createrepackingbarcode",
    component:CreateBarcodeRepack
  },
  {
    path:"/report/productloandetails",
    component:LoanDetails
  },
  {
    path:"/stockin/stockininvoicelist",
    component:StockInInvoiceList
  },

  {
    path:"/report/stockinbatchreport",
    component:BatchReportForStockIn
  },
  {
    path:"/report/stockoutbatchreport",
    component:BatchReportStockOut
  },
  {
    path:"/report/customercreditreport",
    component:CustomerCreditReport
  },
  {
    path:"/stockin/stockinadminaction",
    component:StockInAdminAction
  },
  //StockInAdminEdit
  {
    path:"/stockin/:id/stockinadminrevert",
    component:StockInAdminRevert
  },
  {
    path:"/lctracking/pilists",
    component:PiLists
  },
  {
    path:"/lctracking/createpi",
    component:CreatePI
  },
  {
    path:"/lctracking/:id/updatepi",
    component:UpdatePI
  },
 {
    path:"/lctracking/:id/updatelcdoc",
    component:LcDocAndPaymentUpdate
  },
  {
    path:"/lctracking/listlcanddoc",
    component:LcDocAndPaymentList
  },

  {
    path:"/lctracking/createlcdoc",
    component:LcDocAndPaymentCreate
  },
  {
    path: "/lctracking/:id/limitedupdate",
    component: LcLimitedUpdate,
  },
  {
    path:"/lctracking/documentactionlist",
    component:DocumentActionList
  },
  {
    path:"/lctracking/lcpaymentlist",
    component:LCPaymentList
  },
  {
    path:"/lctracking/:id/lcpayment",
    component:LCPaymentEntry
  },
  
  {
    path:"/stockin/priceupdatelist",
    component:StockInPriceEditList
  },
  {
    path:"/stockin/:id/updateprice",
    component:StockInPriceUpdate
  },
  {
    path:"/stockin/invoicereport",
    component:ProdctInReport
  },
  {
    path:"/report/salesnpayment",
    component:CustomerPaymentSales
  },
  {
    path:"/report/loanreports",
    component:LoanReports
  },
  {
    path:"/report/purchasepricehistory",
    component:PurchasePriceHistoryReport
  },
  {
    path: "/report/dashboardlive",
    component: DashboardLive
  },
  {
    path: "/report/productoutadmin",
    component: ProductOutForAdmin
  },
  {
    path: "/report/packedbyreport",
    component: RepackingPackedByReport
  },
  {
    path: "/report/getstockbyproduct",
    component: CurrentStockByProduct
  },
   {
    path: "/report/reconcileaudit",
    component: CurrentStockReconcileAuditReports
  },
  {
    path:"/customers/flagupdate",
    component:CustomerFlagUpdate
  },
  {
    path:"/report/monthlycreditreport",
    component:MonthlyCreditReportForMd
  },
{
  path:"/customers/taxndutylist",
  component:TaxAndDutyList
}, {
    path: "/taxandduty/add",
    component: AddTaxAndDuty,
  },
  {
    path: "/taxandduty/:id/edit",
    component: EditTaxAndDuty,
  },
{
    path: "/report/taxaitdetailsreport",
    component: TaxAitDetailsReport
  },
  {
    path: "/report/taxaitsummarreport",
    component: TaxAitSummaryReport
  },
  {
    path: "/report/productinsummaryreport",
    component: StockInSummaryReport
  },
 
   {
    path: "/report/stockoutwithsalesreturn",
    component:  ReportStockOutWithStockIn
  },
  {
    path: "/lctracking/lctrackingreport",
    component: LCTrackingReport
  },
   {
    path: "/salesoperation/stockoutstockrevert",
    component:  DeliveryReturnInventoryRestoration
  }, 
  {
    path: "/salesoperation/escalationlist",
    component:  EscalationListPage
  },
  {
    path: "/escalation/EscalationCockpitPage/:orderId",
    component:  EscalationCockpitPage
  },
  {
  path: '/lc-payments/:id/edit',
  component: LcPaymentEdit,

},
{
  path: '/lc-payments/list',
  component: LcPaymentEditList,

}
,
{
  path: '/task/newtask',
  component: AddTaskInvoiceFree,

},
{
  path: '/task/:id/create',
  component: AddTask,

}

  ///...reportRoutes,
];

